import React from "react";
import { MapPin, Navigation } from "lucide-react";
import { getPointAddress, getDirectionsUrl } from "Components/Map/mapPointTypes";

// Address of a location, taken from its linked map point, with a directions link.
const LocationAddress = ({ point, className = "" }) => {
  const address = getPointAddress(point);
  if (!address) return null;
  const hasCoords = Number.isFinite(point.lat) && Number.isFinite(point.lng);

  return (
    <div className={`flex items-start gap-2 text-sm text-slate-300 ${className}`}>
      <MapPin size={18} className="mt-0.5 flex-shrink-0 text-amber-400" />
      <div className="min-w-0">
        <p className="leading-snug">{address}</p>
        {hasCoords && (
          <a
            href={getDirectionsUrl(point)}
            target="_blank"
            rel="noopener noreferrer"
            className="mt-1 inline-flex items-center gap-1 text-xs font-semibold text-amber-400 hover:text-amber-300 transition"
          >
            <Navigation size={12} /> Itinéraire
          </a>
        )}
      </div>
    </div>
  );
};

export default LocationAddress;
